import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { Box, Grid } from "@material-ui/core";
import moment from "moment";
import "moment/min/locales";
import { Control, Controller } from "react-hook-form";
import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

/** Import entities */
import { CxQuestion } from "../../entity/entities";

/** Import constants */
import { MAX_DATE, MIN_DATE, DEFAULT_FORMATED_DATE } from "../../constant/Enum";

/** Import reducer */
import { changeCalendar } from "./PreviewReducer";

/** Import hooks */
import { useAppDispatch, useAppSelector } from "../../app/hooks";

/** Import components */
import { QuestionText } from "../question/QuestionText";

/** Import util */
import LocalizedUtil, { getLocaleForCalendar } from "../../util/LocalizedUtil";

export function Calendar(props: {
  pageIndex: number;
  questionIndex: number;
  cxQuestion: CxQuestion;
  control: Control<any>;
}) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { control, pageIndex, questionIndex, cxQuestion } = props;
  
  useLayoutEffect(() => {
    moment.locale(getLocaleForCalendar())
  }, [])

  const answerStr = useAppSelector((state) => {
    const cxQuestionPage = state.preview.answer[pageIndex];
    const cxQuestion = cxQuestionPage.cxAnswers[questionIndex];

    return cxQuestion.answerStr
      ? moment(cxQuestion.answerStr, DEFAULT_FORMATED_DATE, true).format(DEFAULT_FORMATED_DATE)
      : null;
  });

  const handleChange = (date: string | null | undefined) => {
    dispatch(
      changeCalendar({
        pageIndex,
        questionIndex,
        str: date ? moment(date, DEFAULT_FORMATED_DATE, true).format(DEFAULT_FORMATED_DATE) : "",
      })
    );
  };

  return (
    <>
      <QuestionText cxQuestion={cxQuestion} />
      <Box mx={4}>
        <Grid container>
          <Grid item xs={12}>
            <MuiPickersUtilsProvider
              libInstance={moment}
              utils={LocalizedUtil}
              locale={getLocaleForCalendar()}
            >
              <Controller
                control={control}
                name={`calendar-${pageIndex}-${questionIndex}`}
                render={({ field: { onChange, onBlur, ref, ...rest } }) => (
                  <KeyboardDatePicker
                    {...rest}
                    emptyLabel="yyyy/mm/dd"
                    invalidLabel=""
                    invalidDateMessage={t("preview.calender.incorrect_date_format")}
                    minDateMessage={t("preview.calender.cannot_set_date_before_min_year", { minYear: 1900 })}
                    maxDateMessage=""
                    animateYearScrolling
                    autoOk
                    okLabel={<></>}
                    cancelLabel={<></>}
                    showTodayButton
                    todayLabel={<>{t('preview.calender.today')}</>}
                    clearable
                    clearLabel={<>{t('preview.btn.delete')}</>}
                    margin="normal"
                    format={DEFAULT_FORMATED_DATE}
                    value={answerStr}
                    maxDate={MAX_DATE}
                    onChange={(event, date) => {
                      handleChange(date);
                      onChange(event, date);
                      onBlur();
                    }}
                  />
                )}
                rules={{
                  validate: {
                    validFormat: (v) => {
                      const isValidDate = moment(v, DEFAULT_FORMATED_DATE, true).isValid()
                      return !v || isValidDate;
                    },
                    validMin: (v) =>
                      !v || moment(v, DEFAULT_FORMATED_DATE, true).isSameOrAfter(moment(MIN_DATE)),
                  },
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
